module.exports = __webpack_public_path__ + "static/media/img_1.b38cc8f3.png";